import { JSX } from 'react';

import { Routes } from 'react-router';

import { SentryRoute as Route } from '@vk-hr-tek/core/monitoring';

import { PageError } from '../../../layout';
import { AuthById } from '../AuthById';
import { AuthList } from '../AuthList';

import { Login } from './Login';
import { VerifyInvite } from './VerifyInvite';
import { Register } from './Register';
import { ChangePassword } from './ChangePassword';
import { SendInvite } from './SendInvite';

export const GeneralAuth = (): JSX.Element => {
  return (
    <Routes>
      <Route path="login" element={<Login />} />
      <Route path="register" element={<Register />} />
      <Route path="invite" element={<VerifyInvite />} />
      <Route path="send-invite" element={<SendInvite />} />
      <Route path="change-password" element={<ChangePassword />} />
      <Route path="auth-list" element={<AuthList />} />
      <Route path=":id">
        <Route path="*" element={<AuthById />} />
      </Route>
      <Route path="*" element={<PageError status={404} />} />
    </Routes>
  );
};
